// Take response data and layout as input

import { isEmpty } from 'lodash'
import { useDispatch } from 'react-redux'
import { string } from 'yup'
import { getVideosGalleryDataAsync } from '../../redux/services/apiCalls'

// Retun UI Component name, layout object and value for UI component
export function getDataForLayout(data, layout) {
  console.log('\n\n>>>>>>>layout type : ', layout.type)

  if (layout.type == LayoutInfoType.displayProperties) {
    return [UIComponentName.displayProperties, layout, data.display_properties]
  } else if (layout.type == LayoutInfoType.desc) {
    if (data.item_type === 'HOTEL') {
      return [
        UIComponentName.atAGlance,
        layout,
        { desc: data.description, rating: data.properties.star_rating },
      ]
    } else {
      return [
        UIComponentName.atAGlance,
        layout,
        { desc: data.description, rating: '' },
      ]
    }
  } else if (layout.type == LayoutInfoType.sectionBreak) {
    var layoutValue = { ...layout }

    let result = layoutValue.display_name.includes('__city__')
    if (result) {
      // Replace __city__ with city name
      let city = data.address.city
      if (city) {
        layoutValue.display_name = layoutValue.display_name.replace(
          '__city__',
          city,
        )
      } else {
        layoutValue.display_name = layoutValue.display_name.replace(
          '__city__',
          '',
        )
      }
    }
    return [UIComponentName.hotelSeparator, layoutValue, layoutValue]
    // return [UIComponentName.hotelSeparator, layout, layout]
  } else if (layout.type == LayoutInfoType.text) {
    let value = getValueFromInnerObjects(data, layout.name)
    return [UIComponentName.text, layout, value]
  } else if (layout.type == LayoutInfoType.bulletList) {
    let value = getValueFromInnerObjects(data, layout.name)
    return [UIComponentName.bulletList, layout, value]
  } else if (layout.type == LayoutInfoType.source) {
    let value = getValueFromInnerObjects(data, layout.name)
    return [UIComponentName.source, layout, value]
  } else if (layout.type == LayoutInfoType.keyValue) {
    let value = getValueFromInnerObjects(data, layout.name)
    return [UIComponentName.keyValue, layout, value]
  } else if (layout.type == LayoutInfoType.transports) {
    let value = getValueFromInnerObjects(data, layout.name)
    return [UIComponentName.hotelTransports, layout, value]
  } else if (layout.type == LayoutInfoType.customList) {
    let value = getValueFromInnerObjects(data, layout.name)
    return [UIComponentName.customList, layout, value]
  } else if (layout.type == LayoutInfoType.amenities) {
    let value = getValueFromInnerObjects(data, layout.name)
    return [UIComponentName.hotelAmenities, layout, value]
  } else if (layout.type == LayoutInfoType.reviews) {
    return [UIComponentName.review, layout, data.reviews]
  } else if (layout.type == LayoutInfoType.value) {
    if (layout.name == LayoutName.stayFeatures) {
      return [UIComponentName.stayFeatured, layout, layout.value]
    } else if (layout.name == LayoutName.stayTips) {
      return [UIComponentName.stayTips, layout, layout.value]
    } else if (layout.name == LayoutName.hotelBanner) {
      return [UIComponentName.hotelBanner, layout, layout.value]
    } else if (layout.name == LayoutName.tripBanner) {
      return [UIComponentName.tripBanner, layout, layout.value]
    } else if (layout.name == LayoutName.infoIncluded) {
      return [UIComponentName.checkList, layout, layout.value]
    } else if (layout.name == LayoutName.cancellationPolicy) {
      return [UIComponentName.mainBulletList, layout, layout.value]
    }
  }
  return []
}

function getValueFromInnerObjects(data, name) {
  let nameComponent = name.split('.')
  if (nameComponent.length > 1) {
    // Get data from innner object
    let outerObjectName = nameComponent[0]
    let innerObjectName = nameComponent[1]

    if (outerObjectName == 'additional_info') {
      return getValueFromAdditionalInfoObjects(data, innerObjectName)
    } else if (outerObjectName == 'new_properties') {
      return getValueFromNewPropertyObjects(data, innerObjectName)
    } else if (outerObjectName == 'hotel_properties') {
      return getValueFromHotelPropertyObjects(data, innerObjectName)
    }
  }
  return null
}

function getValueFromAdditionalInfoObjects(data, innerObjectName) {
  let outerValue = data.additional_info
  if (outerValue.length > 0) {
    for (var i = 0; i < outerValue.length; i++) {
      let item = outerValue[i]
      if (item.name == innerObjectName) {
        return item.value
        break
      }
    }
  }
}

function getValueFromNewPropertyObjects(data, innerObjectName) {
  let outerValue = data.new_properties
  console.log('>>>>>>> New property ', outerValue)
  if (outerValue.length > 0) {
    for (var i = 0; i < outerValue.length; i++) {
      let item = outerValue[i]
      if (item.name == innerObjectName) {
        return item.value
        break
      }
    }
  }
}

function getValueFromHotelPropertyObjects(data, innerObjectName) {
  let outerValue = data.hotel_properties
  console.log('>>>>>>> Hotel property ', outerValue)
  if (outerValue.length > 0) {
    for (var i = 0; i < outerValue.length; i++) {
      let item = outerValue[i]
      if (item.name == innerObjectName) {
        return item.value
        break
      }
    }
  }
}

export const LayoutInfoType = {
  reviews: 'reviews',
  images: 'images',
  desc: 'description',
  sectionBreak: 'section_break',
  components: 'components',
  additionalInfo: 'additional_info',
  html: 'html',
  value: 'value',
  mapView: 'map',
  displayProperties: 'display_properties',
  bulletList: 'list-bullet',
  text: 'text',
  source: 'source',
  customList: 'list-custom',
  keyValue: 'key_value',
  banner: 'banner',
  lineSeparator: 'line_separator',
  transports: 'transports',
  amenities: 'amenities',
}

export const LayoutName = {
  stayFeatures: 'stay_features',
  stayTips: 'stay_tips',
  reviews: 'reviews',
  hotelImages: 'hotel_images',
  aboutHotel: 'about_the_hotel',
  thingsToDo: 'things_to_do',
  activityList: 'activity_list',
  attractionList: 'attraction_list',
  additionalInfo: 'additional_info',
  map: 'map',
  hotelBanner: 'hotel_banner',
  infoIncluded: 'info_included_all',
  cancellationPolicy: 'cancellation_policy_formatted',
  tripBanner: 'trip_banner',
}

export const UIComponentName = {
  media: 'media',
  metaData: 'metaData',
  photos: 'photos',
  mediaWithVideo: 'mediaWithVideo',
  mapView: 'mapView',
  component: 'component',
  stayTips: 'stayTips',
  hotelBanner: 'hotelBanner',
  checkList: 'checkList',
  mainBulletList: 'mainBulletList',
  customList: 'customList',
  keyValue: 'keyValue',
  banner: 'banner',
  tripInfo: 'tripInfo',
  hotelAmenities: 'hotelAmenities',
  hotelTransports: 'hotelTransports',
  tripBanner: 'tripBanner',
  review: 'review',
  atAGlance: 'atAGlance',
  hotelSeparator: 'hotelSeparator',
  additionalInfo: 'additionalInfo',
  displayProperties: 'displayProperties',
  source: 'source',
  text: 'text',
  bulletList: 'bulletList',
  stayFeatured: 'stayFeatured',
  checkList: 'checkList',
  lineSeparator: 'lineSeparator',
}

export function convertKeyValueDataIntoList(keyValueData) {
  console.log('>>>>>>> keyValueData : ', keyValueData)

  const newKeyValuePairList = []
  for (const [key, value] of Object.entries(keyValueData)) {
    const newKeyValuePair = {}
    if (typeof value == 'string') {
      newKeyValuePair.key = key
      newKeyValuePair.value = value
      newKeyValuePairList.push(newKeyValuePair)
    } else if (typeof value == 'object') {
      let flatValue = ''
      value.map((item, i) => {
        flatValue = flatValue + ' ' + item
      })
      newKeyValuePair.key = key
      newKeyValuePair.value = flatValue
      newKeyValuePairList.push(newKeyValuePair)
    }
  }
  return newKeyValuePairList
}

export function imagesGalleryModal(obj) {
  console.log(obj)
  let images = []
  if (!isEmpty(obj)) {
    images = obj.content.map((item, index) => {
      return {
        src: item.twoX.fullscreen,
        src2: item.twoX.square,
        fullscreen: item.twoX.fullscreen,
        thumbnail: item.twoX.thumbnail,
        width: '100',
        height: '100',
        key: index,
      }
    })
  }
  return images
}

export function imagesSlidesModal(obj) {
  let images = []
  if (!isEmpty(obj)) {
    images = obj.content.map((item, index) => {
      return {
        src: item.twoX.fullscreen,
        src2: item.twoX.square,
        fullscreen: item.twoX.fullscreen,
        thumbnail: item.twoX.thumbnail,
        width: '100%',
        height: '100%',
        key: index,
      }
    })
  }
  return images
}

export function videosGalleryModal(obj) {
  console.log('>>>>obj', obj)

  let videos = []
  if (!isEmpty(obj)) {
    videos = obj.content.map((item, index) => {
      return {
        src: item.image.twoX.square,
        thumbnail: item.image.twoX.square,
        src2: item.video_url.med,
        height: '400',
        width: '400',
        key: index,
      }
    })
  }
  return videos
}

export function videosSlidesModal(obj) {
  let videos = []
  if (!isEmpty(obj)) {
    videos = obj.content.map((item) => {
      return {
        sources: [
          {
            src: item.video_url.med,
            type: 'video/mp4',
          },
        ],
        height: '100%',
        width: '100%',
        //   key: index,
        poster: item.image.twoX.square,
        type: 'video',
        description: item.caption,
      }
    })
  }
  return videos
}

export function getImagesFromHotelProperties(data) {
  let imgObj = []
  if (!isEmpty(data) && data.hasOwnProperty('hotel_properties')) {
    data.hotel_properties.map((item) => {
      if (item.name === 'hotel_images_addt') {
        item.value.map((value) => {
          // let urlArr = []
          value.image_urls.map((url, index) => {
            imgObj.push({
              src: url,
              src2: url,
              fullscreen: url,
              thumbnail: url,
              width: '100',
              height: '100',
              key: index,
            })
          })
          // imgObj.concat(urlArr)
        })
      }
    })
  }
  console.log('util images', imgObj)
  return imgObj
}

export function getImagesSlidesFromHotelProperties(data) {
  let imgObj = []
  if (!isEmpty(data) && data.hasOwnProperty('hotel_properties')) {
    data.hotel_properties.map((item) => {
      if (item.name === 'hotel_images_addt') {
        item.value.map((value) => {
          value.image_urls.map((url, index) => {
            imgObj.push({
              src: url,
              src2: url,
              fullscreen: url,
              thumbnail: url,
              width: '100%',
              height: '100%',
              key: index,
            })
          })
        })
      }
    })
  }
  console.log('util images Slides', imgObj)
  return imgObj
}
